export const calcPages = (totalResults: number, limit: number) => {
  const arr = [];
  for (let i = 1; i <= Math.ceil(totalResults / limit); i++) {
    arr.push(i);
  }
  return arr;
};
